export type MostReadArticleProps = {
  title: string;
  counter: number;
  linkTo: string;
};

export function MostReadArticle({
  title,
  counter,
  linkTo,
}: MostReadArticleProps) {
  return (
    <a className="flex items-start gap-2 py-2 px-4" href={linkTo}>
      <span className="text-center bg-white-100 rounded-full max-h-[26px] min-w-[26px] font-semibold text-sm">
        {counter}
      </span>
      <span className="hover:underline break-words text-2sm border-b border-white-100 w-full pb-3">
        {title}
      </span>
    </a>
  );
}
